import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import logo from '../../assets/log_o.png';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('lgpd_cookie_consent');
    if (!consent) {
      // Small delay to not overwhelm the user immediately on page load
      const timer = setTimeout(() => setIsVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAcceptAll = () => {
    localStorage.setItem('lgpd_cookie_consent', 'accepted');
    setIsVisible(false);
  };

  const handleRejectAll = () => {
    localStorage.setItem('lgpd_cookie_consent', 'rejected');
    setIsVisible(false);
  };

  const handleOpenSettings = () => {
    // For now, settings just logs or can be mapped to future granular modal
    console.log('Open cookie settings');
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: 'spring', stiffness: 200, damping: 25 }}
          className="fixed bottom-0 left-0 right-0 z-50 p-4 md:bottom-6 md:left-6 md:right-auto md:max-w-lg"
        >
          <div className="bg-[#1C1D20] text-gray-300 rounded-2xl shadow-2xl overflow-hidden border border-gray-800 p-6">
            
            <div className="flex items-start gap-4 mb-6">
              <div className="rounded-full shrink-0 flex items-center justify-center mt-1">
                <img src={logo} alt="CriaApp Logo" className="w-9 h-9 object-contain rounded-full" />
              </div>
              <div>
                <p className="text-sm leading-relaxed">
                  Utilizamos cookies e tecnologias semelhantes para fornecer-lhe uma melhor experiência de navegação, bem como para fins de análise e marketing. Pode alterar as suas definições de cookies em qualquer altura ou ler mais sobre a nossa utilização de cookies na nossa Política de Privacidade.
                </p>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-3 items-center justify-between">
              <button 
                onClick={handleOpenSettings}
                className="text-sm font-medium text-gray-400 hover:text-white transition-colors underline underline-offset-2 order-3 sm:order-1"
              >
                Definições de cookies
              </button>
              
              <div className="flex flex-col sm:flex-row w-full sm:w-auto gap-3 order-1 sm:order-2">
                <button 
                  onClick={handleRejectAll}
                  className="px-5 py-2.5 text-sm font-medium text-white bg-transparent border border-gray-600 rounded-lg hover:bg-gray-800 transition-colors w-full sm:w-auto"
                >
                  Rejeitar Todos
                </button>
                <button 
                  onClick={handleAcceptAll}
                  className="px-5 py-2.5 text-sm font-semibold text-black bg-[#00E57B] rounded-lg hover:bg-[#00c96c] transition-colors shadow-[0_0_15px_rgba(0,229,123,0.3)] w-full sm:w-auto"
                >
                  Aceitar todos os cookies
                </button>
              </div>
            </div>
            
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieConsent;
